import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./Views/Home";
import ProductDetails from "./Views/ProductDetails";
import CartProvider from "./context/cartContext";
import OrderDetails from "./Views/OrderDetails";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "product/:categoryId/:productId",
    element: <ProductDetails />,
  },
  {
    path: "order",
    element: <OrderDetails />,
  },
]);

function App() {
  return (
    <CartProvider>
      <RouterProvider router={router} />
    </CartProvider>
  );
}

export default App;
